import type { TColumn } from './guide.types';
import { getDomainValue } from 'utils/domain';

const baseColumns: TColumn[] = [
  {
    title: '',
    dataIndex: 'footLength',
    key: 'feet.length',
  },
];

if (getDomainValue({ nnormal: true }) === true) {
  baseColumns.push({
    title: '',
    dataIndex: 'equivalent',
    key: 'feet.length.in',
    defaultValue: '*** Foot length (in)',
  });
}

export const columns = {
  baseColumns,
};
